"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterContainer = exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const device_1 = require("@completeanatomy/device");
const model_systems_1 = require("@completeanatomy/model-systems");
const models_1 = require("@completeanatomy/models");
const models_panel_1 = require("@completeanatomy/models-panel");
function Footer({ isBodyRegionsButtonDisabled }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const selectedPart = (0, models_1.useSelectedPart)();
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { timeout: 200, in: !isMobile || !(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.name), mountOnEnter: true, unmountOnExit: true, children: (0, jsx_runtime_1.jsxs)(exports.FooterContainer, { "$isMobile": isMobile, "$isModel": true, children: [(0, jsx_runtime_1.jsx)(models_panel_1.BodyRegionsButton, { disabled: isBodyRegionsButtonDisabled }), (0, jsx_runtime_1.jsx)(model_systems_1.SystemsMenu, {})] }) }));
}
exports.Footer = Footer;
exports.default = Footer;
/**
 * @todo Remove this once RegionButton is implemented as part of MainPageLayout
 */
const REGION_BUTTON_WIDTH = 0;
exports.FooterContainer = styled_components_1.default.div `
  z-index: 1;
  position: absolute;
  bottom: 0;
  left: ${REGION_BUTTON_WIDTH}px;

  display: flex;

  width: ${({ $isMobile, theme }) => $isMobile
    ? `calc(100vw - ${REGION_BUTTON_WIDTH}px)`
    : `calc(100vw - ${theme.mainMenuWidth}px - ${REGION_BUTTON_WIDTH}px)`};
  height: ${({ theme, $isModel }) => $isModel ? '' : `${theme.footerHeight}px`};

  background: ${({ theme, $isMobile }) => $isMobile ? 'rgba(33, 36, 43, 0.95)' : theme.backgroundWithOpacity};

  transition: transform 0.2s ease-in-out;

  &.enter {
    transform: translateY(100%);
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.enter-done {
    transform: none;
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(100%);
  }

  /*
   * Hack for legacy modes
   * @todo Remove later
   */

  [question-editing-mode] &,
  [quiz-play-view] &,
  [quizzes-view] &,
  [screens-mode] &,
  [playing-lecture] & {
    transform: translateY(100%);
  }

  [live-mode] &,
  [toolkit-active] & {
    display: none;
  }
`;
